import React from "react";
import { useEffect, useState } from "react";
import SchoolHeader from "../../HospitalHeader";
import Footer from "../../Footer";
import moment from "moment/moment";
import { IoFilter } from "react-icons/io5";
import { Col, Container, Row, Card, Form, Dropdown } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { DataGrid } from "@mui/x-data-grid";
import schoolServices from "../../../services/school_services";
import { useParams } from "react-router-dom";
import { showErrorMessage } from "../../../services/utils";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import hospitalServices from "../../../services/hospital.services";
const StudentDetailTable = () => {
    const param = useParams()
    const [Fieldval, SetFieldVal] = useState({ selectVal: "" })
    const [StudentDetails, setStudentDetails] = useState([])
    const navigate = useNavigate()
    let columns = [
        // { field: "id", headerName: "ID", width: 100 },
        { field: "first_name", headerName: "Name", width: 250, accessor: "first_name" },
        { field: "phone_number", headerName: "Phone Number", width: 250, accessor: "phone_number" },
        { field: "program_start_date", headerName: "Program Start Date", width: 250, accessor: "program_start_date" },
        { field: "personal_email_address", headerName: "E-Mail", width: 250, accessor: "personal_email_address" },
        // { field: "other_program_info", headerName: "Program Name", width: 200, accessor: "other_program_info" },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {

                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            navigate(`/student-files/${params.rowNode.id}`)
                        }}
                    >
                        <span className="actn_icn">
                            <FaEye title="Preview" />
                        </span>
                    </div>
                );
            },
        },
    ]
    const [rows, setRow] = useState([])
    // const [filterType, setFilterType] = useState({})

    const getStudentDetails = (data) => {
        hospitalServices.getRotationReqStudentDetail(data)
            .then((res) => {
                // setStudentDetails(res.data.data.studentInfos)


                res && res.data && res.data.data.studentInfos.map((curr, index) => {
                    
                    if (curr.program_start_date) {
                        curr.program_start_date = moment(curr.program_start_date).format("MM-DD-YYYY")
                    }

                    curr.id = curr.user_id 

                    setRow(oldRow => ([curr, ...oldRow]))
                })
            })
            .catch((err) =>
                showErrorMessage({ message: err.response.data.errors.msg })
            )





    }


    useEffect(() => {
        getStudentDetails(param.rotation_req_id)


    }, [])

    useEffect(() => {

    }, [])

    // useEffect(() => {
    //     const getStudent = async () => {
    //         const obj = {
    //             programId: param.programId,
    //             schoolId: param.school_id
    //         }

    //         await schoolServices.getStudentUnderProgram(obj).then(resp => {
    //             resp && resp.data && resp.data.map((curr, index) => {
    //                 if (curr.programInfo.program_name === "Other") {
    //                     curr.other_program_info = curr.other_program_info
    //                 }
    //                 else {
    //                     curr.other_program_info = curr.programInfo.program_name
    //                 }
    //                 if (curr.program_start_date) {
    //                     curr.program_start_date = moment(curr.program_start_date).format("MM-DD-YYYY")
    //                 }

    //                 curr.id = curr.user_id

    //                 setRow(oldRow => ([curr, ...oldRow]))
    //             })
    //         }).catch(err => {
    //             showErrorMessage({ message: err.response.data.errors.msg })
    //         })
    //     }
    //     getStudent()

    // }, [])

    // useEffect(() => {
    //     if (Fieldval.year && Fieldval.month) {
    //         const getStudent = async () => {
    //             const obj = {
    //                 programId: param.programId,
    //                 schoolId: param.school_id,
    //                 year: Fieldval?.year ? Fieldval?.year : moment().format("YYYY"),
    //                 month: Fieldval?.month ? Fieldval?.month : moment().format("M")
    //             }

    //             await schoolServices.getStudentUnderProgram(obj).then(resp => {
    //                 setRow([])
    //                 resp && resp.data && resp.data.map((curr, index) => {
    //                     if (curr.programInfo.program_name === "Other") {
    //                         curr.other_program_info = curr.other_program_info
    //                     }
    //                     else {
    //                         curr.other_program_info = curr.programInfo.program_name
    //                     }
    //                     if (curr.program_start_date) {
    //                         curr.program_start_date = moment(curr.program_start_date).format("MM-DD-YYYY")
    //                     }
    //                     curr.id = curr.user_id

    //                     setRow(oldRow => ([curr, ...oldRow]))
    //                 })
    //             }).catch(err => {
    //                 showErrorMessage({ message: err.response.data.errors.msg })
    //             })
    //         }
    //         getStudent()
    //     }


    // }, [Fieldval.selectVal])
    return (
        <div className="dashbrd_pg ">
            <SchoolHeader />
            <div className="fls_cllctn_wrap schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap stu_date">
                        {/* <div className="srch_fld d-inline-block">
                            <Form.Group
                                className="mb-3 position-relative"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Control
                                    type={filterType.dob ? "date":"text"}
                                    placeholder="Search here"
                                />
                                <Dropdown className="srch_fltr">
                                    <Dropdown.Toggle
                                        variant=""
                                        id="dropdown-basic"
                                    >
                                        <IoFilter />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Header>
                                            Filter by
                                        </Dropdown.Header>
                                        <Dropdown.Item onClick={() => {
                                            setFilterType({ email: true, dob: false, grad_date: false })
                                        }}>
                                            Email
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => {
                                            setFilterType({ dob: true, email: false, grad_date: false })
                                        }}>
                                            Date of Birth
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                        </div> */}
                        <div className="files_fldrs">
                            <Row>
                                <Col md={12}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="all_files ">
                                                <div className="tbl_hdng d-flex justify-content-between align-items-center mb-4">
                                                    <h5 className="mb-0">
                                                        Student List
                                                    </h5>
                                                </div>
                                                {/* <div style={{ width: "300px" }} className="tbl_hdng d-flex justify-content-between align-items-center mb-4">
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DatePicker
                                                            inputFormat="yyyy-MM"
                                                            views={['month', 'year']}
                                                            label="Gradutaion Start Month and Year"
                                                            value={Fieldval?.selectVal ? Fieldval.selectVal : null}
                                                            placeholder="Enter Date of Birth"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue

                                                            ) => {
                                                                if (newValue._d) {
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "month": moment(newValue._d).format("M"),
                                                                        "year": moment(newValue._d).format("yyyy"),
                                                                        "selectVal": newValue._d
                                                                    })
                                                                }

                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                />
                                                            )}
                                                            maxDate={new Date()}
                                                        />
                                                    </LocalizationProvider>
                                                </div> */}

                                                <div className="docs_tbl">
                                                    <div
                                                        style={{
                                                            height: 400,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <DataGrid
                                                            rows={rows && rows}
                                                            columns={columns}
                                                            pageSize={5}
                                                            rowsPerPageOptions={[
                                                                5,
                                                            ]}
                                                        // checkboxSelection
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default StudentDetailTable;
